import { Event } from "interfaces/content";

import React from "react";
import styled from "styled-components";
import styles from "styles/styles";
import { ics } from "calendar-link";

import useTranslate from "hooks/common/useTranslate/useTranslate";
import useLocale from "hooks/common/useLocale/useLocale";
import { hasPassed, isWithinDay } from "utils/dateAndTime";

const StyledAddToCalendarLink = styled.a`
    font-style: italic;
    font-size: ${styles.fontSize.smaller};
    color: ${styles.colors.grey7};
`;

interface Props {
    event: Event;
}

/**
 * Checks if an event can be added to the calendar. Current thresholds are
 * 30 minutes after the end time for events with an end time, and 90 minutes after the start time for events without an end time.
 * @param event The event to check.
 * @returns True if the event can be added to the calendar, false otherwise.
 */
export const isAddableToCalendar = (event: Event) =>
    event.endDate ? !hasPassed(event.endDate) : !hasPassed(event.date, 90);

export const isJoinable = (event: Event) => isWithinDay(event.date) && isAddableToCalendar(event);

export default ({ event }: Props) => {
    const translate = useTranslate();
    const locale = useLocale();

    return (
        <StyledAddToCalendarLink
            onClick={(e) => e.stopPropagation()}
            href={ics({
                title: event.description[locale] ?? "Fingrid Webinar",
                description: event.weblink,
                start: event.date,
                end: event.endDate,
                duration: !event.endDate ? [0.5, "hour"] : undefined,
            })}
            target="_blank"
        >
            {translate("common.addToCalendar")}
        </StyledAddToCalendarLink>
    );
};
